import { shallowEqual, useSelector } from 'react-redux';
import useActiveEpisode from './useActiveEpisode';
import useAudioTimes from './useAudioTimes';
import { selectAudioPaused } from '@/state/selectors/audio';

const selector = (state) => ({ paused: selectAudioPaused(state) });

const useMusicPlayerState = () => {
  const { episode } = useActiveEpisode();
  const { paused } = useSelector(selector, shallowEqual);

  const times = useAudioTimes();

  return {
    paused,
    episode,
    times
  };
};

export default useMusicPlayerState;